function PaginatedObject() {
    this.Id = -1;
    this.PageNumber = 0;
    this.PageSize = 10;
    this.TotalCount = 0;
    this.TotalPages = 0;
    this.__type = "PaginatedObject:www.veritracks.com";
}
if (typeof exports !== 'undefined') {
    module.exports = PaginatedObject;
}